/**
 * M6, M7: rótulos legíveis para o que o servidor devolve cru (nomes de campo, valores, ações, entidades,
 * módulos). Palavras soltas (snake_case e camelCase viram palavras) para cobrir qualquer chave nova com
 * tradução decente; `campos` só guarda os casos irregulares. Namespace `nucleo`, chave `rotulos`.
 */
const PALAVRAS = `
desde|Desde|From|Desde
execucao|Execução|Performance|Ejecución
interesse|Interesse|Interest|Interés
legal|Legal|Lawful|Legal
legitimo|Legítimo|Legitimate|Legítimo
externos|Externos|External|Externos
neutro|Neutro|Neutral|Neutro
sr|Sr.|Mr.|Sr.
sra|Sra.|Ms.|Sra.
tratamento|Tratamento|Form of address|Tratamiento
sexo|Sexo|Sex|Sexo
masculino|Masculino|Male|Masculino
feminino|Feminino|Female|Femenino
informado|Informado|Provided|Informado
residencial|Residencial|Home|Residencial
fax|Fax|Fax|Fax
obrigacao|Obrigação|Obligation|Obligación
resumo|Resumo|Summary|Resumen
sabe|Sabe|Knows|Sabe
seguidor|Seguidor|Follower|Seguidor
ultimo|Último|Last|Último
vazio|Vazio|Empty|Vacío
vendas|Vendas|Sales|Ventas
auto|Automática|Automatic|Automática
estrelas|Estrelas|Stars|Estrellas
perguntas|Perguntas|Questions|Preguntas
qualificar|Qualificar|Qualify|Calificar
campanhas|Campanhas|Campaigns|Campañas
fontes|Fontes|Sources|Fuentes
listas|Listas|Lists|Listas
livres|Livres|Free|Libres
aceita|Aceita|Accepted|Aceptada
adiar|Adiar|Postpone|Posponer
apresentacao|Apresentação|Introduction|Presentación
cartoes|Cartões|Cards|Tarjetas
condicoes|Condições|Terms|Condiciones
estatistica|Estatística|Statistic|Estadística
max|máx.|max|máx.
objetivo|Objetivo|Goal|Objetivo
obrigatoria|Obrigatória|Required|Obligatoria
outros|Outros|Other|Otros
pagina|Página|Page|Página
passos|Passos|Steps|Pasos
playbook|Playbook|Playbook|Playbook
anotacao|Anotação|Note|Anotación
celebrar|Celebrar|Celebrate|Celebrar
central|Central de Arquivos|File library|Central de archivos
predefinido|Predefinido|Preset|Predefinido
proposta|Proposta|Proposal|Propuesta
qualificacao|Qualificação|Rating|Calificación
quando|Quando|When|Cuando
questionario|Questionário|Questionnaire|Cuestionario
responsaveis|Responsáveis|Owners|Responsables
rodape|Rodapé|Footer|Pie
sugerir|Sugerir|Suggest|Sugerir
vazios|Vazios|Empty|Vacíos
vendido|Vendido|Won|Vendido
workflow|Workflow|Workflow|Workflow
aviso|Aviso|Alert|Aviso
sinal|Sinal|Signal|Señal
virar|Virar|Turn into|Convertir en
analise|Análise|Review|Análisis
corrigido|Corrigido|Fixed|Corregido
navegador|Navegador|Browser|Navegador
novo|Novo|New|Nuevo
pilha|Pilha|Stack|Pila
render|Exibição da tela|Screen rendering|Visualización de la pantalla
request|Requisição|Request|Solicitud
rota|Rota|Route|Ruta
simulado|Simulado|Simulated|Simulado
acrescentar|Acrescentar|Add|Agregar
tirar|Tirar|Remove|Quitar
marcar|Marcar|Mark|Marcar
verticais|Verticais|Business units|Verticales
vertical|Vertical|Business unit|Vertical
docx|Arquivo do Word|Word file|Archivo de Word
garantidor|Garantidor|Guarantor|Garante
para|Para|For|Para
regimes|Regimes|Tax regimes|Regímenes
servicos|Serviços|Services|Servicios
agendado|Agendado|Scheduled|Programado
autorizou|Autorizou|Opted in|Autorizó
avisos|Avisos|Notices|Avisos
broadcast|Broadcast|Broadcast|Difusión
clicou|Clicou|Clicked|Hizo clic
consentimento|Consentimento|Consent|Consentimiento
declarar|Declarar|Declare|Declarar
disparar|Disparar|Send|Enviar
enviando|Enviando|Sending|Enviando
registrar|Registrar|Record|Registrar
ritmo|Ritmo|Rate|Ritmo
saiu|Saiu|Opted out|Salió
setores|Setores|Sectors|Sectores
tipos|Tipos|Types|Tipos
gatilho|Gatilho|Trigger|Disparador
botoes|Botões|Buttons|Botones
cabecalho|Cabeçalho|Header|Encabezado
exemplos|Exemplos|Examples|Ejemplos
imagem|Imagem|Image|Imagen
maton|Maton|Maton|Maton
zernio|Zernio|Zernio|Zernio
gravacao|Gravação|Recording|Grabación
transcricao|Transcrição|Transcript|Transcripción
sala|Sala|Room|Sala
pronta|Pronta|Ready|Lista
ajuste|Ajuste|Adjustment|Ajuste
cerca|Cerca virtual|Geofence|Cerca virtual
contratos|Contratos|Contracts|Contratos
foto|Foto|Photo|Foto
dica|Dica|Tip|Pista
rever|Rever|See again|Ver otra vez
vista|Vista|Seen|Vista
futuro|Futuro|Future|Futuro
hoje|Hoje|Today|Hoy
latitude|Latitude|Latitude|Latitud
localizacao|Localização|Location|Ubicación
longitude|Longitude|Longitude|Longitud
marcacao|Marcação|Punch|Registro
relogio|Relógio|Time clock|Reloj
marca|Marca|Brand|Marca
leitura|Leitura|Reading|Lectura
esquecer|Esquecer|Forget|Olvidar
crc|CRC|CRC|CRC
importacao|Importação|Import|Importación
normal|Normal|Normal|Normal
politica|Política|Policy|Política
ponto|Ponto|Time clock|Jornada
precisao|Precisão|Accuracy|Precisión
raio|Raio|Radius|Radio
reaberto|Reaberto|Reopened|Reabierto
tolerancia|Tolerância|Tolerance|Tolerancia
web|Web|Web|Web
agora|Agora|Now|Ahora
anexado|Anexado|Attached|Adjuntado
nova|Nova|New|Nueva
tags|Etiquetas|Tags|Etiquetas
automacao|Automação|Automation|Automatización
bpo|BPO|Finance outsourcing|BPO
dp|DP|Payroll|Nómina
feriado|Feriado|Holiday|Feriado
horarios|Horários|Times|Horarios
legalizacao|Legalização|Corporate|Legalización
pendencia|Pendência|Pending item|Pendiente
resolver|Resolver|Resolve|Resolver
resolvida|Resolvida|Resolved|Resuelta
rodando|Rodando|Running|En ejecución
rodar|Rodar|Run|Ejecutar
ti|TI|IT|TI
util|Útil|Business|Hábil
classe|Situação|Status|Situación
diferentes|Só as diferenças|Differences only|Solo las diferencias
divergente|Divergente|Different|Divergente
igual|Igual|Same|Igual
ciente|Ciente|Aware|Consciente
classificar|Classificar|Classify|Clasificar
etiqueta|Etiqueta|Label|Etiqueta
etiquetas|Etiquetas|Labels|Etiquetas
feriados|Feriados|Holidays|Feriados
invalida|Inválida|Invalid|Inválida
menu|Menu|Menu|Menú
palavra|Palavra|Word|Palabra
palavras|Palavras|Words|Palabras
permissao|Permissão|Permission|Permiso
personalizado|Personalizado|Custom|Personalizado
presenca|Presença|Presence|Presencia
rotear|Encaminhar|Route|Encaminar
lugar|Lugar|Place|Lugar
subsistemas|Sub-sistemas|Subsystems|Subsistemas
embutir|Abrir dentro do MalgoOS|Open inside MalgoOS|Abrir dentro de MalgoOS
trocas|Trocas|Changes|Cambios
desligados|Desligados|Turned off|Desactivados
desagendar|Cancelar agendamento|Unschedule|Cancelar programación
ativado|Ativado|Activated|Activado
dispensar|Dispensar|Skip|Omitir
ex|Ex|Former|Ex
alterada|Alterada|Changed|Modificada
bloquear|Bloquear|Block|Bloquear
casado|Casado|Matched|Coincidente
desfeita|Desfeita|Undone|Deshecha
indicado|Indicado|Referred|Referido
migrado|Migrado|Migrated|Migrado
executar|Executar|Run|Ejecutar
ganho|Ganho|Win|Ganancia
lead|Lead|Sales lead|Lead
chat|Chat|Live chat|Chat en vivo
dominios|Domínios|Domains|Dominios
lgpd|LGPD|Privacy (LGPD)|Privacidad (LGPD)
pedir|Pedir|Ask for|Pedir
saudacao|Saudação|Greeting|Saludo
widget|Widget|Chat widget|Widget del chat
passo|Etapa|Step|Etapa
personalizar|Personalizar|Customize|Personalizar
tarefas|Tarefas|Tasks|Tareas
destinatarios|Destinatários|Recipients|Destinatarios
diaria|Diária|Daily|Diaria
entregas|Entregas|Deliveries|Entregas
frequencia|Frequência|Frequency|Frecuencia
mascarar|Mascarar|Mask|Enmascarar
mensal|Mensal|Monthly|Mensual
periodo|Período|Period|Período
salvo|Salvo|Saved|Guardado
semanal|Semanal|Weekly|Semanal
antes|Antes|Before|Antes
depois|Depois|After|Después
herdar|Seguir o padrão|Use the default|Seguir el predeterminado
usar|Usar|Use|Usar
geral|De todas as empresas|All companies|De todas las empresas
celular|Celular|Mobile|Móvil
gerado|Gerado|Generated|Generado
legenda|Legenda|Caption|Leyenda
versao|Versão|Version|Versión
acesso|Acesso|Access|Acceso
area|Área|Area|Área
como|Como|As|Como
convidado|Convidado|Invited|Invitado
portal|Portal|Portal|Portal
publicar|Publicar|Publish|Publicar
revogado|Revogado|Revoked|Revocado
termo|Termo de uso|Terms of use|Términos de uso
webpush|Web Push|Web Push|Web Push
asaas|Asaas|Asaas|Asaas
sicredi|Sicredi|Sicredi|Sicredi
automatica|Automática|Automatic|Automática
cartao|Cartão de crédito|Credit card|Tarjeta de crédito
indefinida|O cliente escolhe|Customer chooses|El cliente elige
adicionar|Adicionar|Add|Agregar
apagada|Apagada|Deleted|Borrada
apagar|Apagar|Delete|Borrar
entrar|Entrar|Join|Unirse
escopo|Escopo|Scope|Alcance
lido|Lido|Read|Leído
meus|Meus|Mine|Míos
participante|Participante|Member|Participante
participantes|Participantes|Members|Participantes
publicos|Públicos|Public|Públicos
sair|Sair|Leave|Salir
visibilidade|Visibilidade|Visibility|Visibilidad
compartilhado|Compartilhado|Shared|Compartido
compartilhamento|Compartilhamento|Sharing|Uso compartido
consolidado|Consolidado|Consolidated view|Consolidado
modo_simples|Modo simples|Simple mode|Modo simple
simples|Simples|Simple|Simple
devolver|Devolver ao grupo|Return to the group|Devolver al grupo
distribuir|Distribuir|Distribute|Distribuir
separado|Separado|Separate|Separado
bruta|Bruta|Gross|Bruta
clientes|Clientes|Customers|Clientes
componentes|Componentes|Components|Componentes
custos|Custos|Costs|Costos
deducoes|Deduções|Deductions|Deducciones
despesas|Despesas|Expenses|Gastos
eliminados|Eliminados|Eliminated|Eliminados
extratos|Extratos|Statements|Extractos
fase|Fase|Stage|Fase
faixa|Faixa|Bucket|Tramo
fora|Fora|Outside|Fuera
fornecedores|Fornecedores|Suppliers|Proveedores
fornecimento|Condições de compra|Purchase terms|Condiciones de compra
grupos|Grupos|Groups|Grupos
intercompany|Entre empresas do grupo|Between group companies|Entre empresas del grupo
lado|Lado|Side|Lado
operacionais|Operacionais|Operating|Operativos
operacional|Operacional|Operating|Operativo
parametros|Parâmetros|Parameters|Parámetros
recorrencias|Recorrências|Recurring invoices|Recurrencias
relatorio|Relatório|Report|Informe
relatorios|Relatórios|Reports|Informes
publicacao|Publicação|Publication|Publicación
separados|Separados|Shown|Separados
acoes|Ações|Actions|Acciones
anomalia|Alerta de anomalia|Anomaly alert|Alerta de anomalía
aprovacao|Aprovação|Approval|Aprobación
assistente|Assistente|Assistant|Asistente
assistentes|Assistentes|Assistants|Asistentes
atual|Atual|Current|Actual
ble|Bluetooth|Bluetooth LE|Bluetooth
cable|Celular por cabo|Phone by cable|Celular por cable
cadastrar|Cadastrar|Register|Registrar
exclusoes|Exclusões|Deletions|Eliminaciones
expirada|Expirada|Expired|Vencida
falhar|Falhar|Fail|Fallar
hybrid|Celular por perto|Nearby phone|Celular cercano
internal|Neste aparelho|This device|Este dispositivo
janela|Janela|Window|Ventana
maximo|Máximo|Maximum|Máximo
nfc|Aproximação (NFC)|Tap (NFC)|Acercamiento (NFC)
niveis|Níveis de risco|Risk levels|Niveles de riesgo
passkey|Passkey|Passkey (device key)|Passkey
preparar|Preparar|Prepare|Preparar
prova|Prova|Proof|Prueba
recusada|Recusada|Declined|Rechazada
recusar|Recusar|Decline|Rechazar
restaurar|Restaurar|Restore|Restaurar
suspender|Suspender|Suspend|Suspender
transportes|Formas de conexão|Connection types|Formas de conexión
usb|Cabo USB|USB cable|Cable USB
ajustar|Ajustar|Adjust|Ajustar
inventariar|Inventariar|Count stock|Inventariar
movimentar|Movimentar|Move stock|Mover stock
aprovar|Aprovar|Approve|Aprobar
receber|Receber|Receive|Recibir
transferir|Transferir|Transfer|Transferir
conectores|Conectores|Connectors|Conectores
webhooks|Webhooks|Webhooks|Webhooks
backups|Códigos de backup|Backup codes|Códigos de respaldo
falha|Falha|Failure|Fallo
licenca|Licença|License|Licencia
login|Login|Sign in|Inicio de sesión
mfa|Verificação em duas etapas|Two-step verification|Verificación en dos pasos
outras|Outras|Others|Otras
regerar|Gerar de novo|Regenerate|Generar de nuevo
resetar|Redefinir|Reset|Restablecer
senha|Senha|Password|Contraseña
sessao|Sessão|Session|Sesión
sessoes|Sessões|Sessions|Sesiones
trocar|Trocar|Change|Cambiar
troca|Troca|Change|Cambio
provisoria|Provisória|Temporary|Provisoria
ajuda|Ajuda|Help|Ayuda
cadastral|Cadastral|Registration|Catastral
capital|Capital|Capital|Capital
consultas|Consultas|Lookups|Consultas
encontrado|Encontrado|Found|Encontrado
estadual|Estadual|State|Estatal
fiscal|Fiscal|Tax|Fiscal
iban|IBAN|IBAN|IBAN
ie|IE|State registration|IE
inscricao|Inscrição|Registration|Inscripción
inscricoes|Inscrições|Registrations|Inscripciones
isento|Isento|Exempt|Exento
juridica|Jurídica|Legal|Jurídica
municipal|Municipal|Municipal|Municipal
porte|Porte|Size|Tamaño
produtor|Produtor|Producer|Productor
regime|Regime|Regime|Régimen
rural|Rural|Rural|Rural
swift|SWIFT|SWIFT|SWIFT
vinculo|Vínculo|Link|Vínculo
abaixo|Abaixo|Below|Debajo
agente|Agente|Agent|Agente
card|Card|Task card|Tarjeta
coluna|Coluna|Column|Columna
comentada|Comentada|Commented|Comentada
comentar|Comentar|Comment|Comentar
espera|Espera|Waits|Espera
exige|Exige|Requires|Exige
prioridade|Prioridade|Priority|Prioridad
quadro|Quadro|Board|Tablero
tamanho|Tamanho|Size|Tamaño
tarefa|Tarefa|Task|Tarea
wip|WIP (em andamento)|WIP|WIP (en curso)
app|No sistema|In the app|En el sistema
auth|Chave de autenticação|Authentication key|Clave de autenticación
comercial|Comercial|Sales|Comercial
configuracao|Configuração|Setting|Configuración
dispositivo|Aparelho|Device|Dispositivo
endpoint|Endereço do push|Push endpoint|Dirección del push
grafico|Gráfico|Chart|Gráfico
inscrever|Inscrever|Subscribe|Suscribir
link|Endereço|Link|Enlace
mencoes|Menções|Mentions|Menciones
notificacoes|Notificações|Notifications|Notificaciones
operacao|Operação|Operations|Operación
push|Notificação push|Push notification|Notificación push
sintetica|Sintética|Summary|Sintética
sistema|Sistema|System|Sistema
abertos|Abertos|Open|Abiertos
admitido|Admitido|Hired|Dado de alta
agendamentos|Agendamentos|Appointments|Citas
atualizado|Atualizado|Updated|Actualizado
baixas|Baixas|Settlements|Liquidaciones
compra|Compra|Purchase|Compra
criada|Criada|Created|Creada
criado|Criado|Created|Creado
emitida|Emitida|Issued|Emitida
envio|Envio|Sending|Envío
isolamento|Isolamento|Isolation|Aislamiento
mesclado|Mesclado|Merged|Combinado
movida|Movida|Moved|Movida
paga|Paga|Paid|Pagada
parceiros|Parceiros|Partners|Socios
registrado|Registrado|Recorded|Registrado
recusado|Recusado|Refused|Rechazado
titulos|Títulos|Bills|Títulos
vencida|Vencida|Overdue|Vencida
vinculos|Vínculos|Links|Vínculos
abrir|Abrir|Open|Abrir
abreviatura|Abreviatura|Short name|Abreviatura
agendavel|Agendável|Bookable|Agendable
simular|Simular|Preview|Simular
uso|Uso|Use|Uso
venda|Venda|Sale|Venta
acao|Ação|Action|Acción
acento|Cor de destaque|Accent color|Color de acento
admin|Admin|Admin|Admin
admissao|Admissão|Hire date|Admisión
admitir|Admitir|Hire|Admitir
afastado|Afastado|On leave|Con licencia
afastar|Afastar|Place on leave|Dar licencia
agenda|Agenda|Schedule|Agenda
agendamento|Agendamento|Appointment|Cita
ajustes|Ajustes|Adjustments|Ajustes
alvo|Alvo|Target|Destino
anexar|Anexar|Attach|Adjuntar
anexo|Anexo|Attachment|Adjunto
anexos|Anexos|Attachments|Adjuntos
aplicacao|Aplicação|Application|Aplicación
anual|Anual|Annual|Anual
aplicada|Aplicada|Applied|Aplicada
antigos|Antigos|Old|Antiguos
so|Só|Only|Solo
ano|Ano|Year|Año
aprovada|Aprovada|Approved|Aprobada
assunto|Assunto|Subject|Asunto
atividade|Atividade|Activity|Actividad
ativa|Ativa|Active|Activa
ativo|Ativo|Active|Activo
atributo|Atributo|Attribute|Atributo
atribuir|Atribuir|Assign|Asignar
aula|Aula|Lesson|Clase
aberta|Aberta|Open|Abierta
avista|À vista|Upfront|Al contado
baixa|Baixa|Payment|Pago
baixar|Dar baixa|Settle|Registrar pago
barras|Barras|Barcode|Barras
base|Base|Base|Base
beneficio|Benefício|Benefit|Beneficio
beneficios|Benefícios|Benefits|Beneficios
biblioteca|Biblioteca|Library|Biblioteca
bloqueio|Bloqueio|Block|Bloqueo
cadastros|Cadastros|Records|Registros
caixa|Caixa|Cash|Caja
calcular|Calcular|Calculate|Calcular
calculada|Calculada|Calculated|Calculada
calendario|Calendário|Calendar|Calendario
campanha|Campanha|Campaign|Campaña
campo|Campo|Field|Campo
canal|Canal|Channel|Canal
cancelado|Cancelado|Canceled|Cancelado
cancelamento|Cancelamento|Cancellation|Cancelación
cancelar|Cancelar|Cancel|Cancelar
capa|Capa|Cover|Portada
cargo|Cargo|Position|Cargo
carga|Carga|Load|Carga
categoria|Categoria|Category|Categoría
centavos|Valor|Amount|Valor
centro|Centro|Center|Centro
centros|Centros|Centers|Centros
certificado|Certificado|Certificate|Certificado
chave|Chave|Key|Clave
claro|Claro|Light|Claro
cliente|Cliente|Customer|Cliente
clt|CLT|CLT|CLT
codigo|Código|Code|Código
compras|Compras|Purchasing|Compras
competencia|Competência|Period|Período
comportamental|Comportamental|Behavioral|Conductual
comprovante|Comprovante|Receipt|Comprobante
conciliado|Conciliado|Reconciled|Conciliado
conciliar|Conciliar|Reconcile|Conciliar
concluida|Concluída|Completed|Completada
concluido|Concluído|Completed|Completado
concluir|Concluir|Complete|Completar
condicao|Condição|Terms|Condición
conferida|Conferida|Reviewed|Revisada
conferir|Conferir|Review|Revisar
configuracoes|Configurações|Settings|Configuración
confirmacao|Confirmação|Confirmation|Confirmación
confirmado|Confirmado|Confirmed|Confirmado
confirmar|Confirmar|Confirm|Confirmar
conta|Conta|Account|Cuenta
contados|Contados|Counted|Contados
contar|Contar|Count|Contar
contas|Contas|Accounts|Cuentas
contrato|Contrato|Contract|Contrato
controla|Controla|Tracks|Controla
conversas|Conversas|Conversations|Conversaciones
convertida|Convertida|Converted|Convertida
convidar|Convidar|Invite|Invitar
convite|Convite|Invitation|Invitación
cor|Cor|Color|Color
corpo|Corpo|Body|Cuerpo
cotacao|Cotação|Quote|Cotización
cpf|CPF|CPF|CPF
criar|Criar|Create|Crear
curso|Curso|Course|Curso
cursos|Cursos|Courses|Cursos
custo|Custo|Cost|Costo
data|Data|Date|Fecha
de|De|From|De
definir|Definir|Set|Definir
demo|Demonstração|Demo|Demostración
departamento|Departamento|Department|Departamento
deposito|Depósito|Warehouse|Depósito
desconto|Desconto|Deduction|Descuento
descontos|Descontos|Deductions|Descuentos
descricao|Descrição|Description|Descripción
desligado|Desligado|Terminated|Dado de baja
desligamento|Desligamento|Termination|Baja
desligar|Desligar|Terminate|Dar de baja
destino|Destino|Destination|Destino
dia|Dia|Day|Día
dias|Dias|Days|Días
digitos|Dígitos|Digits|Dígitos
documento|Documento|Document|Documento
documentos|Documentos|Documents|Documentos
duracao|Duração|Duration|Duración
editar|Editar|Edit|Editar
email|E-mail|Email|Correo
emails|E-mails|Emails|Correos
emissao|Emissão|Issue date|Emisión
emitir|Emitir|Issue|Emitir
empresa|Empresa|Company|Empresa
encargo|Encargo|Employer charge|Cargo patronal
encargos|Encargos|Employer charges|Cargas patronales
endereco|Endereço|Address|Dirección
enviada|Enviada|Sent|Enviada
enviado|Enviado|Sent|Enviado
entidade|Entidade|Entity|Entidad
entidades|Entidades|Entities|Entidades
entrega|Entrega|Delivery|Entrega
equipe|Equipe|Team|Equipo
escala|Escala|Shift pattern|Turno
escolhida|Escolhida|Chosen|Elegida
escuro|Escuro|Dark|Oscuro
especial|Especial|Special|Especial
estado|Situação|Status|Estado
estagio|Estágio|Internship|Pasantía
estoque|Estoque|Stock|Inventario
estornado|Estornado|Reversed|Revertido
estornar|Estornar|Reverse|Revertir
estorno|Estorno|Reversal|Reversión
etapa|Etapa|Stage|Etapa
etapas|Etapas|Stages|Etapas
copiar|Copiar|Copy|Copiar
funil|Funil|Pipeline|Embudo
funis|Funis|Pipelines|Embudos
evento|Evento|Event|Evento
eventos|Eventos|Events|Eventos
excecoes|Exceções|Exceptions|Excepciones
extras|Campos extras|Extra fields|Campos extra
extrato|Extrato|Statement|Extracto
fabricacao|Fabricação|Manufacturing|Fabricación
faltar|Registrar falta|Mark absent|Registrar falta
faltou|Faltou|Absent|Faltó
fantasia|Fantasia|Trade name|Nombre comercial
fechada|Fechada|Closed|Cerrada
fechamento|Fechamento|Closing|Cierre
fechando|Fechando|Closing|Cerrando
fechar|Fechar|Close|Cerrar
fgts|FGTS|FGTS|FGTS
fim|Fim|End|Fin
financeiro|Financeiro|Finance|Finanzas
fonte|Fonte|Source|Fuente
forma|Forma|Method|Forma
formas|Formas|Methods|Formas
formato|Formato|Format|Formato
fornecedor|Fornecedor|Supplier|Proveedor
folha|Folha|Payroll|Nómina
funcao|Função|Role|Cargo
funcionario|Funcionário|Employee|Empleado
funcionarios|Funcionários|Employees|Empleados
ganha|Ganha|Won|Ganada
ganhar|Ganhar|Win|Ganar
geracao|Geração|Generation|Generación
gestao|Gestão|Management|Gestión
gestor|Gestor|Manager|Gerente
habilidade|Habilidade|Skill|Habilidad
holerites|Holerites|Payslips|Nóminas
hora|Hora|Time|Hora
horaria|Horária|Hourly|Horaria
horario|Horário|Schedule|Horario
horas|Horas|Hours|Horas
id|Código interno|Internal ID|ID interno
idioma|Idioma|Language|Idioma
idiomas|Idiomas|Languages|Idiomas
ids|Códigos internos|Internal IDs|IDs internos
ignoradas|Ignoradas|Ignored|Ignoradas
ignorados|Ignorados|Ignored|Ignorados
importadas|Importadas|Imported|Importadas
importar|Importar|Import|Importar
incide|Incide em|Applies to|Incide en
inadimplencia|Inadimplência|Overdue payments|Morosidad
inadimplente|Inadimplente|In arrears|En mora
regularizado|Regularizado|Back in good standing|Regularizado
reativado|Reativado|Reactivated|Reactivado
indicacao|Indicação|Referral|Referencia
inicio|Início|Start|Inicio
integracoes|Integrações|Integrations|Integraciones
inventario|Inventário|Inventory|Inventario
inss|INSS|INSS|INSS
irrf|IRRF|IRRF|IRRF
item|Item|Item|Ítem
itens|Itens|Items|Ítems
juros|Juros|Interest|Intereses
justificativa|Justificativa|Justification|Justificación
lancamento|Lançamento|Entry|Asiento
lancamentos|Lançamentos|Entries|Asientos
lancar|Lançar|Post|Registrar
landing|Página de captura|Landing page|Página de captura
linha|Linha|Line|Línea
lista|Lista|List|Lista
liquido|Líquido|Net|Neto
local|Local|Location|Ubicación
logo|Logo|Logo|Logo
lote|Lote|Batch|Lote
manual|Manual|Manual|Manual
marcado|Marcado|Scheduled|Programado
matricula|Matrícula|Enrollment|Matrícula
matricular|Matricular|Enroll|Matricular
matriculados|Matriculados|Enrolled|Matriculados
meta|Meta|Goal|Meta
membros|Membros|Members|Miembros
mes|Mês|Month|Mes
midia|Mídia|Medium|Medio
min|min|min|min
minimo|Mínimo|Minimum|Mínimo
modelo|Modelo|Template|Plantilla
modo|Modo de operação|Operating mode|Modo de operación
modulo|Módulo|Module|Módulo
moeda|Moeda|Currency|Moneda
motivo|Motivo|Reason|Motivo
movimentacao|Movimentação|Movement|Movimiento
movimentacoes|Movimentações|Movements|Movimientos
mover|Mover|Move|Mover
multa|Multa|Penalty|Multa
nascimento|Nascimento|Birth date|Nacimiento
natureza|Natureza|Type|Naturaleza
nenhum|Nenhum|None|Ninguno
nivel|Nível|Level|Nivel
nome|Nome|Name|Nombre
numero|Número|Number|Número
obrigatorio|Obrigatório|Required|Obligatorio
observacao|Observação|Note|Observación
observacoes|Observações|Notes|Observaciones
oportunidade|Oportunidade|Opportunity|Oportunidad
opcoes|Opções|Options|Opciones
orcamento|Orçamento|Budget|Presupuesto
ordem|Ordem|Order|Orden
origem|Origem|Source|Origen
padrao|Padrão|Default|Predeterminado
pagamento|Pagamento|Payment|Pago
pago|Pago|Paid|Pagado
papel|Papel|Role|Rol
parceiro|Parceiro|Partner|Socio
parcela|Parcela|Installment|Cuota
parcelas|Parcelas|Installments|Cuotas
parcial|Parcial|Partial|Parcial
parent|Superior|Parent|Superior
pausada|Pausada|Paused|Pausada
pausar|Pausar|Pause|Pausar
pct|%|%|%
pdfs|PDFs|PDFs|PDFs
pedido|Pedido|Order|Pedido
pendente|Pendente|Pending|Pendiente
percentual|Percentual|Percentage|Porcentaje
perda|Perda|Loss|Pérdida
perdida|Perdida|Lost|Perdida
perder|Perder|Lose|Perder
periodicidade|Periodicidade|Frequency|Periodicidad
permissoes|Permissões|Permissions|Permisos
pessoas|Pessoas|People|Personas
pipeline|Pipeline|Pipeline|Pipeline
pj|PJ|Contractor|Contratista
por|Por|By|Por
pre|Pré|Pre|Pre
prazo|Prazo|Deadline|Plazo
preco|Preço|Price|Precio
prefixo|Prefixo|Prefix|Prefijo
previsao|Previsão|Forecast|Previsión
prevista|Prevista|Planned|Prevista
probabilidade|Probabilidade|Probability|Probabilidad
produto|Produto|Product|Producto
projeto|Projeto|Project|Proyecto
provedor|Provedor|Provider|Proveedor
proventos|Proventos|Earnings|Ingresos
proxima|Próxima|Next|Próxima
proximo|Próximo|Next|Próximo
publicado|Publicado|Published|Publicado
quantidade|Quantidade|Quantity|Cantidad
rascunho|Rascunho|Draft|Borrador
ignorar|Ignorar|Ignore|Ignorar
retencao|Retenção|Retention|Retención
ranking|Ranking|Ranking|Ranking
razao|Razão|Legal|Razón
realizado|Realizado|Done|Realizado
realizar|Realizar|Carry out|Realizar
recebido|Recebido|Received|Recibido
recebimento|Recebimento|Receipt|Recepción
recorrencia|Recorrência|Recurrence|Recurrencia
recurso|Recurso|Resource|Recurso
recusa|Recusa|Refusal|Rechazo
reinicio|Reinício|Restart|Reinicio
requisicao|Requisição|Requisition|Requisición
requisito|Requisito|Requirement|Requisito
responsavel|Responsável|Owner|Responsable
rosa|Rosa|Pink|Rosa
azul|Azul|Blue|Azul
ciano|Ciano|Cyan|Cian
laranja|Laranja|Orange|Naranja
verde|Verde|Green|Verde
pt|Português|Portuguese|Portugués
en|Inglês|English|Inglés
es|Espanhol|Spanish|Español
true|Sim|Yes|Sí
false|Não|No|No
null|Vazio|Empty|Vacío
rotulo|Rótulo|Label|Etiqueta
roxo|Roxo|Purple|Morado
salario|Salário|Salary|Salario
saldo|Saldo|Balance|Saldo
sem|Sem|No|Sin
sensivel|Sensível|Sensitive|Sensible
sentido|Sentido|Direction|Sentido
sequencia|Sequência|Sequence|Secuencia
serie|Série|Series|Serie
servico|Serviço|Service|Servicio
setor|Setor|Sector|Sector
site|Site|Website|Sitio web
sku|SKU|SKU|SKU
social|Social|Name|Social
solicitante|Solicitante|Requester|Solicitante
status|Situação|Status|Estado
tag|Etiqueta|Tag|Etiqueta
tecnica|Técnica|Technical|Técnica
telefone|Telefone|Phone|Teléfono
telefones|Telefones|Phones|Teléfonos
temporario|Temporário|Temporary|Temporal
tema|Tema|Theme|Tema
tipo|Tipo|Type|Tipo
titulo|Título|Title|Título
total|Total|Total|Total
trabalho|Trabalho|Work|Trabajo
treinamento|Treinamento|Training|Capacitación
trilha|Trilha|Learning path|Ruta
ultima|Última|Last|Última
unidade|Unidade|Unit|Unidad
unitario|Unitário|Unit|Unitario
url|URL|URL|URL
usuario|Usuário|User|Usuario
utm|UTM|UTM|UTM
validade|Validade|Expiry|Vencimiento
valor|Valor|Amount|Valor
valores|Valores|Values|Valores
variacao|Variação|Variant|Variante
variavel|Variável|Variable|Variable
vencimento|Vencimento|Due date|Vencimiento
video|Vídeo|Video|Video
webhook|Webhook|Webhook|Webhook
whatsapp|WhatsApp|WhatsApp|WhatsApp
instagram|Instagram|Instagram|Instagram
fila|Fila|Queue|Cola
distribuicao|Distribuição|Distribution|Distribución
assinatura|Assinatura|Signature|Firma
rodizio|Rodízio|Round robin|Rotación
workspace|Workspace|Workspace|Workspace
a|A|Coming|Por
aberto|Aberto|Open|Abierto
agencia|Agência|Branch|Sucursal
agendar|Agendar|Schedule|Agendar
agrupar|Agrupar|Group by|Agrupar
alerta|Alerta|Alert|Alerta
andamento|Andamento|Progress|Curso
aparencia|Aparência|Appearance|Apariencia
api|API|API|API
aprovado|Aprovado|Approved|Aprobado
arquivados|Arquivados|Archived|Archivados
arquivar|Arquivar|Archive|Archivar
arquivo|Arquivo|File|Archivo
portfolio|Portfólio|Portfolio|Portafolio
asc|Crescente|Ascending|Ascendente
ate|Até|Until|Hasta
atendente|Atendente|Agent|Agente
ativas|Ativas|Active|Activas
ativos|Ativos|Active|Activos
atrasadas|Atrasadas|Overdue|Atrasadas
autenticacao|Autenticação|Authentication|Autenticación
bairro|Bairro|District|Barrio
bancaria|Bancária|Bank|Bancaria
banco|Banco|Bank|Banco
boleto|Boleto|Bank slip|Boleto
busca|Busca|Search|Búsqueda
campos|Campos|Fields|Campos
canais|Canais|Channels|Canales
cancelada|Cancelada|Canceled|Cancelada
cep|CEP|ZIP code|Código postal
cidade|Cidade|City|Ciudad
cobertura|Cobertura|Coverage|Cobertura
cobranca|Cobrança|Collection|Cobro
cobrar|Cobrar|Charge|Cobrar
code|Código|Code|Código
colunas|Colunas|Columns|Columnas
complemento|Complemento|Address line 2|Complemento
comprado|Comprado|Purchased|Comprado
conciliacao|Conciliação|Reconciliation|Conciliación
conciliada|Conciliada|Reconciled|Conciliada
concluidas|Concluídas|Completed|Completadas
concluidos|Concluídos|Completed|Completados
conectar|Conectar|Connect|Conectar
conector|Conector|Connector|Conector
conferido|Conferido|Reviewed|Revisado
configurar|Configurar|Configure|Configurar
contato|Contato|Contact|Contacto
conteudo|Conteúdo|Content|Contenido
conversa|Conversa|Conversation|Conversación
comentario|Comentário|Comment|Comentario
botao|Botão|Button|Botón
fluxo|Automação de conversa|Conversation automation|Automatización de conversación
aguardando|Aguardando|Waiting|Esperando
pausado|Pausado|Paused|Pausado
ligacoes|Ligações|Connections|Conexiones
revisao|Revisão|Revision|Revisión
gerar|Gerar|Generate|Generar
segredo|Segredo|Secret|Secreto
clicado|Clicado|Clicked|Pulsado
converter|Converter|Convert|Convertir
credencial|Credencial|Credential|Credencial
creditos|Créditos|Credits|Créditos
csv|CSV|CSV|CSV
cursor|Cursor|Cursor|Cursor
dados|Dados|Data|Datos
desativar|Desativar|Deactivate|Desactivar
desconectar|Desconectar|Disconnect|Desconectar
parear|Parear|Pair|Vincular
desc|Decrescente|Descending|Descendente
desfazer|Desfazer|Undo|Deshacer
desinstalar|Desinstalar|Uninstall|Desinstalar
despesa|Despesa|Expense|Gasto
direcao|Direção|Direction|Dirección
dono|Dono|Owner|Propietario
em|Em|In|En
empresas|Empresas|Companies|Empresas
encerrada|Encerrada|Ended|Finalizada
encerrar|Encerrar|End|Finalizar
entrada|Entrada|Inflow|Entrada
entregue|Entregue|Delivered|Entregado
enviar|Enviar|Send|Enviar
erro|Erro|Error|Error
error|Erro|Error|Error
escopos|Escopos|Scopes|Alcances
excluir|Excluir|Delete|Eliminar
expira|Expira|Expires|Expira
exportacao|Exportação|Export|Exportación
exportar|Exportar|Export|Exportar
exportacoes|Exportações|Exports|Exportaciones
externo|Externo|External|Externo
falhou|Falhou|Failed|Falló
fatura|Fatura|Invoice|Factura
fechado|Fechado|Closed|Cerrado
filtro|Filtro|Filter|Filtro
filtros|Filtros|Filters|Filtros
forcar|Forçar|Force|Forzar
gerada|Gerada|Generated|Generada
google|Google|Google|Google
habilitar|Habilitar|Enable|Habilitar
historico|Histórico|History|Historial
holerite|Holerite|Payslip|Recibo de nómina
ignorado|Ignorado|Ignored|Ignorado
inativos|Inativos|Inactive|Inactivos
inicial|Inicial|Initial|Inicial
iniciar|Iniciar|Start|Iniciar
instalar|Instalar|Install|Instalar
lembretes|Lembretes|Reminders|Recordatorios
lidas|Lidas|Read|Leídas
ligada|Ligada|On|Activada
ligado|Ligado|On|Activado
limite|Limite|Limit|Límite
limpar|Limpar|Clear|Borrar
logradouro|Logradouro|Street|Calle
marketing|Marketing|Marketing|Marketing
material|Material|Material|Material
mcp|MCP|MCP|MCP
membro|Membro|Member|Miembro
mensagem|Mensagem|Message|Mensaje
mensagens|Mensagens|Messages|Mensajes
geo|Geografia|Geography|Geografía
us|Estados Unidos|United States|Estados Unidos
ia|IA|AI|IA
granularidade|Agrupamento|Grouping|Agrupación
mesclar|Mesclar|Merge|Fusionar
minhas|Minhas|Mine|Mías
minimos|Mínimos|Minimum|Mínimos
mudar|Mudar|Change|Cambiar
nao|Não|No|No
nota|Nota|Note|Nota
oauth|OAuth|OAuth|OAuth
ofx|OFX|OFX|OFX
ok|OK|OK|OK
onboarding|Integração inicial|Onboarding|Incorporación
ordenacao|Ordenação|Sorting|Ordenación
outro|Outro|Other|Otro
pontos|Pontos|Points|Puntos
legado|Legado|Legacy|Heredado
pagar|Pagar|Payable|Pagar
pais|País|Country|País
papeis|Papéis|Roles|Roles
pendentes|Pendentes|Pending|Pendientes
pessoa|Pessoa|Person|Persona
pix|Pix|Pix|Pix
plano|Plano|Plan|Plan
posicao|Posição|Position|Posición
principal|Principal|Main|Principal
processado|Processado|Processed|Procesado
promover|Promover|Promote|Promover
rapida|Rápida|Quick|Rápida
reabrir|Reabrir|Reopen|Reabrir
reativar|Reativar|Reactivate|Reactivar
recebida|Recebida|Received|Recibida
receita|Receita|Revenue|Ingreso
reenviar|Reenviar|Resend|Reenviar
registro|Registro|Record|Registro
regua|Lembretes de cobrança|Dunning schedule|Calendario de cobro
rejeitado|Rejeitado|Rejected|Rechazado
remarcar|Remarcar|Reschedule|Reprogramar
remover|Remover|Remove|Quitar
reordenar|Reordenar|Reorder|Reordenar
repontar|Repontar|Repoint|Reasignar
ligar|Ligar|Link|Vincular
resposta|Resposta|Reply|Respuesta
resultado|Resultado|Result|Resultado
retornar|Retornar|Return|Reincorporar
revogar|Revogar|Revoke|Revocar
autorizar|Autorizar|Authorize|Autorizar
conexao|Conexão|Connection|Conexión
rotacionar|Rotacionar|Rotate|Rotar
saida|Saída|Outflow|Salida
salvar|Salvar|Save|Guardar
sandbox|Sandbox|Sandbox|Sandbox
seg|seg|sec|seg
semana|Semana|Week|Semana
sim|Sim|Yes|Sí
situacao|Situação|Status|Situación
slug|Identificador|Slug|Identificador
state|Estado|State|Estado
suspenso|Suspenso|Suspended|Suspendido
tela|Tela|Screen|Pantalla
template|Modelo|Template|Plantilla
tenant|Workspace|Workspace|Workspace
testar|Testar|Test|Probar
teste|Teste|Test|Prueba
texto|Texto|Text|Texto
ator|Autor|Actor|Autor
avatar|Foto do perfil|Profile photo|Foto del perfil
textos|Textos|Texts|Textos
titular|Titular|Holder|Titular
todas|Todas|All|Todas
todos|Todos|All|Todos
administrar|Administrar|Manage|Administrar
auditoria|Auditoria|Audit log|Auditoría
confidencial|Confidencial|Confidential|Confidencial
modulos|Módulos|Modules|Módulos
tenants|Tenants|Tenants|Tenants
usuarios|Usuários|Users|Usuarios
ver|Ver|View|Ver
tool|Ferramenta|Tool|Herramienta
transferencia|Transferência|Transfer|Transferencia
uf|UF|State|Estado
utilidade|Utilidade|Utility|Utilidad
valido|Válido|Valid|Válido
variaveis|Variáveis|Variables|Variables
vencendo|Vencendo|Due soon|Por vencer
vencer|Vencer|Due|Vencer
vencido|Vencido|Overdue|Vencido
visao|Visão|View|Vista
perdido|Perdido|Written off|Perdido
renegociado|Renegociado|Renegotiated|Renegociado
renegociada|Renegociada|Renegotiated|Renegociada
estornada|Estornada|Reversed|Revertida
renegociar|Renegociar|Renegotiate|Renegociar
renegociacao|Renegociação|Renegotiation|Renegociación
apropriacao|Apropriação|Allocation|Apropiación
categorias|Categorias|Categories|Categorías
dre|DRE|Income statement|Estado de resultados
e|e|and|y
externa|Externa|External|Externa
grupo|Grupo|Group|Grupo
tarifa|Tarifa|Fee|Comisión
assinaturas|Assinaturas|Subscriptions|Suscripciones
cobrancas|Cobranças|Billings|Cobros
com|Com|With|Con
encerrado|Encerrado|Ended|Finalizado
indice|Índice|Index|Índice
intervalo|Intervalo|Interval|Intervalo
meses|Meses|Months|Meses
momento|Momento|Timing|Momento
mrr|MRR|MRR|MRR
reajustado|Reajustado|Adjusted|Reajustado
reajustar|Reajustar|Adjust|Reajustar
atualizar|Atualizar|Update|Actualizar
indices|Índices|Indices|Índices
reajuste|Reajuste|Adjustment|Reajuste
referencia|Referência|Reference|Referencia
vendedor|Vendedor|Salesperson|Vendedor
ausencia|Ausência|Time off|Ausencia
contagem|Contagem|Count|Conteo
pedida|Pedida|Requested|Solicitada
remunerada|Remunerada|Paid|Remunerada
reembolsar|Reembolsar|Reimburse|Reembolsar
reembolso|Reembolso|Reimbursement|Reembolso
arquivado|Arquivado|Archived|Archivado
marco|Marco|Milestone|Hito
marcos|Marcos|Milestones|Hitos
encaixe|Encaixe|Squeeze-in|Encaje
dia_inteiro|Dia inteiro|All day|Todo el día
convite_google|Convite pelo Google|Google invite|Invitación por Google
inteiro|Inteiro|All|Entero
meet|Meet|Meet|Meet
nenhuma|Nenhuma|None|Ninguna
propria|Própria|Own|Propia
quinzenal|Quinzenal|Biweekly|Quincenal
google_meet|Google Meet|Google Meet|Google Meet
reuniao|Reunião|Meeting|Reunión
sala_propria|Sala própria|Own room|Sala propia
convidados|Convidados|Guests|Invitados
`;

const MODULOS = `
admin|Admin|Admin|Admin
documentos|Documentos e assinatura|Documents and signature|Documentos y firma
agenda|Agenda|Schedule|Agenda
assinaturas|Assinaturas e recorrência|Subscriptions and recurring billing|Suscripciones y recurrencia
cadastros|Cadastros|Records|Registros
compras|Compras|Purchasing|Compras
configuracoes|Configurações|Settings|Configuración
contas|Contas|Accounts|Cuentas
conversas|Conversas|Conversations|Conversaciones
equipe|Equipe|Team|Equipo
estoque|Estoque|Inventory|Inventario
financeiro|Financeiro|Finance|Finanzas
folha|Folha de pagamento|Payroll|Nómina
integracoes|Integrações|Integrations|Integraciones
pessoas|Pessoas|People|Personas
pipeline|Pipeline|Pipeline|Pipeline
relatorios|Relatórios|Reports|Informes
tarefas|Tarefas|Tasks|Tareas
portal|Portal do cliente|Client portal|Portal del cliente
treinamento|Treinamento|Training|Capacitación
ausencias|Férias e ausências|Time off|Vacaciones y ausencias
ponto|Registro de ponto|Time clock|Registro de jornada
despesas|Despesas e reembolso|Expenses and reimbursement|Gastos y reembolso
automacoes|Automações|Automations|Automatizaciones
`;

const CAMPOS = `
google_conta|Conta do Google Agenda|Google Calendar account|Cuenta de Google Calendar
agendado_para|Agendado para|Scheduled for|Programado para
consentimento_saiu|Saiu da lista de marketing|Left the marketing list|Salió de la lista de marketing
gravacao_id|Id da gravação|Recording ID|Id de la grabación
duracao_s|Duração (s)|Duration (s)|Duración (s)
fora_do_vinculo|Fora do vínculo|Outside employment|Fuera del vínculo
cerca_raio_m|Raio da cerca (m)|Geofence radius (m)|Radio de la cerca (m)
precisao_m|Precisão (m)|Accuracy (m)|Precisión (m)
client_id|Identificador do cliente|Client ID|Identificador del cliente
client_name|Nome do cliente|Client name|Nombre del cliente
code_challenge|Desafio PKCE|PKCE challenge|Desafío PKCE
code_challenge_method|Método do desafio PKCE|PKCE challenge method|Método del desafío PKCE
csrf|Proteção do formulário|Form protection|Protección del formulario
decisao|Decisão|Decision|Decisión
grant_types|Tipos de concessão|Grant types|Tipos de concesión
token_endpoint_auth_method|Autenticação do cliente|Client authentication|Autenticación del cliente
none|Nenhum|None|Ninguno
redirect_uri|Endereço de volta|Redirect URI|Dirección de retorno
redirect_uris|Endereços de volta|Redirect URIs|Direcciones de retorno
resource|Recurso|Resource|Recurso
response_type|Tipo de resposta|Response type|Tipo de respuesta
response_types|Tipos de resposta|Response types|Tipos de respuesta
scope|Escopo pedido|Requested scope|Alcance pedido
so_la|Só na Conta Azul|Only in Conta Azul|Solo en Conta Azul
so_aqui|Só no MalgoOS|Only in MalgoOS|Solo en MalgoOS
devolver_no_asaas|Devolver pelo Asaas|Refund through Asaas|Devolver por Asaas
estorno_asaas|Estorno no Asaas|Refund at Asaas|Reembolso en Asaas
fonte|Fonte do texto|Text font|Fuente del texto
permitir_fonte_pessoal|Fonte pessoal liberada|Personal font allowed|Fuente personal permitida
modelos|Modelos próprios|Custom models|Modelos propios
estilo_padrao|Estilo de interface padrão|Default interface style|Estilo de interfaz predeterminado
permitir_estilo_pessoal|Estilo pessoal liberado|Personal style allowed|Estilo personal permitido
estilo_fixado|Estilo fixado pelo administrador|Style fixed by the administrator|Estilo fijado por el administrador
marca_nome|Nome da marca|Brand name|Nombre de la marca
marca_logo|Logo da marca|Brand logo|Logo de la marca
escala_texto|Tamanho do texto|Text size|Tamaño del texto
estilo|Estilo de interface|Interface style|Estilo de interfaz
e_parceiro|É indicador / parceiro comercial|Is referrer / business partner|Es referidor / socio comercial
isento_ie|Isento de IE|Exempt from state registration|Exento de IE
capital_social_centavos|Capital social|Share capital|Capital social
parceiro_fiscal|Dados fiscais|Tax data|Datos fiscales
parceiro_regime|Regime tributário|Tax regime|Régimen tributario
parceiro_vinculo|Vínculo entre pessoas|Link between people|Vínculo entre personas
regime_tributario|Regime tributário|Tax regime|Régimen tributario
responsavel_todos|Responsável: Todos|Owner: Everyone|Responsable: Todos
nome_parceiro_principal|Empresa principal|Main company|Empresa principal
nomes_parceiros_adicionais|Empresas adicionais|Additional companies|Empresas adicionales
telefone_tipo|Tipo do telefone|Phone type|Tipo de teléfono
email_adicionais|E-mails adicionais|Additional emails|Correos adicionales
setores_adicionais|Segmentos adicionais|Additional segments|Segmentos adicionales
responsaveis_adicionais|Responsáveis adicionais|Additional owners|Responsables adicionales
parceiro_principal_id|Empresa principal (id)|Main company (id)|Empresa principal (id)
parceiros_adicionais_ids|Empresas adicionais (ids)|Additional companies (ids)|Empresas adicionales (ids)
regime_pretendido|Regime tributário pretendido|Intended tax regime|Régimen tributario previsto
moeda_padrao|Moeda padrão|Default currency|Moneda predeterminada
nao_encontrado|Não encontrado|Not found|No encontrado
aplica_a|Aplica a|Applies to|Se aplica a
e_cliente|É cliente|Is customer|Es cliente
e_fornecedor|É fornecedor|Is supplier|Es proveedor
ja_matriculados|Já matriculados|Already enrolled|Ya matriculados
juros_mes_pct|Juros ao mês (%)|Monthly interest (%)|Interés mensual (%)
multa_pct|Multa (%)|Penalty (%)|Multa (%)
ano_mes|Competência|Period|Período
tema_padrao|Tema padrão|Default theme|Tema predeterminado
idioma_padrao|Idioma padrão|Default language|Idioma predeterminado
cpf|CPF|CPF|CPF
cnpj|CNPJ|CNPJ|CNPJ
documento|Documento|Document|Documento
documento_tipo|Tipo do documento|Document type|Tipo de documento
ip|IP|IP|IP
centro_custo_id|Centro de custo|Cost center|Centro de costo
centro_custo|Centro de custo|Cost center|Centro de costo
forma_pagamento|Forma de pagamento|Payment method|Forma de pago
conta_destino_id|Conta de destino|Destination account|Cuenta de destino
depositoDestinoId|Depósito de destino|Destination warehouse|Depósito de destino
condicao_pagamento|Condição de pagamento|Payment terms|Condición de pago
data_pagamento|Data de pagamento|Payment date|Fecha de pago
data_competencia|Data de competência|Accrual date|Fecha de devengo
data_caixa|Data de caixa|Cash date|Fecha de caja
fornecedor_padrao_id|Fornecedor padrão|Default supplier|Proveedor predeterminado
categoria_despesa_id|Categoria de despesa|Expense category|Categoría de gasto
servico_contratado|Serviço contratado|Contracted service|Servicio contratado
servico_contratado_id|Serviço contratado|Contracted service|Servicio contratado
previsao_fechamento|Previsão de fechamento|Expected close|Cierre previsto
motivo_perda_id|Motivo da perda|Loss reason|Motivo de pérdida
motivo_cancelamento|Motivo do cancelamento|Cancellation reason|Motivo de cancelación
motivo_recusa|Motivo da recusa|Refusal reason|Motivo de rechazo
carga_horaria_min|Carga horária (min)|Hours load (min)|Carga horaria (min)
duracao_min|Duração (min)|Duration (min)|Duración (min)
prazo_entrega_dias|Prazo de entrega (dias)|Lead time (days)|Plazo de entrega (días)
prazo_entrega|Prazo de entrega|Lead time|Plazo de entrega
prazoDias|Prazo (dias)|Term (days)|Plazo (días)
gestor_funcionario_id|Gestor|Manager|Gerente
gestor_id|Gestor|Manager|Gerente
pre_requisito_aula_id|Aula pré-requisito|Prerequisite lesson|Clase previa
pre_requisito_curso_id|Curso pré-requisito|Prerequisite course|Curso previo
estoque_minimo|Estoque mínimo|Minimum stock|Inventario mínimo
reinicio_anual|Reinício anual|Yearly restart|Reinicio anual
horario_trabalho|Horário de trabalho|Working hours|Horario de trabajo
incide_em|Incide em|Applies to|Incide en
lancavel|Recebe lançamento|Accepts entries|Recibe registros
afd|AFD|AFD|AFD
aej|AEJ|AEJ|AEJ
rep_p|Ponto oficial (REP-P)|Official time clock (REP-P)|Control oficial (REP-P)
inpi|Registro no INPI|INPI registration|Registro en el INPI
local_prestacao|Local da prestação|Place of work|Lugar de trabajo
caepf_cno|CAEPF ou CNO|CAEPF or CNO|CAEPF o CNO
desenvolvedor_documento|CNPJ ou CPF do desenvolvedor|Developer tax ID|CNPJ o CPF del desarrollador
desenvolvedor_razao|Razão social do desenvolvedor|Developer company name|Razón social del desarrollador
desenvolvedor_email|E-mail do desenvolvedor|Developer email|Correo del desarrollador
pdf|PDF|PDF|PDF
custoUnitarioCentavos|Custo unitário|Unit cost|Costo unitario
custo_unitario_centavos|Custo unitário|Unit cost|Costo unitario
controla_lote|Controla lote|Tracks batches|Controla lote
codigo_barras|Código de barras|Barcode|Código de barras
fim_contrato|Fim do contrato|Contract end|Fin del contrato
contrato_tipo|Tipo de contrato|Contract type|Tipo de contrato
logo_anexo_id|Logo|Logo|Logo
capa_anexo_id|Capa|Cover|Portada
comprovante_anexo_id|Comprovante|Receipt|Comprobante
sem_email|Sem e-mail|Without email|Sin correo
created_at|Criado em|Created at|Creado el
updated_at|Atualizado em|Updated at|Actualizado el
nao_lidas|Não lidas|Unread|No leídas
expira_em|Expira em|Expires on|Expira el
recebida_em|Recebida em|Received on|Recibida el
chave_pix|Chave Pix|Pix key|Clave Pix
saldo_inicial_centavos|Saldo inicial|Opening balance|Saldo inicial
dono_email|E-mail do dono|Owner email|Correo del propietario
dono_nome|Nome do dono|Owner name|Nombre del propietario
id_externo|Código externo|External ID|ID externo
contato_externo|Contato externo|External contact|Contacto externo
workspace_slug|Identificador do workspace|Workspace slug|Identificador del workspace
converter_em_projeto|Converter em projeto|Convert to project|Convertir en proyecto
dias_minimos|Dias mínimos|Minimum days|Días mínimos
posicao_seg|Posição (seg)|Position (sec)|Posición (seg)
onboarding_concluido|Integração concluída|Onboarding completed|Incorporación completada
conta_bancaria|Conta bancária|Bank account|Cuenta bancaria
questionario_aplicacao|Questionário aplicado|Applied questionnaire|Cuestionario aplicado
proposta_modelo|Modelo de proposta|Proposal template|Plantilla de propuesta
email_modelo|Modelo de e-mail|Email template|Plantilla de correo
resposta_rapida|Resposta rápida|Quick reply|Respuesta rápida
chave_api|Chave de API|API key|Clave de API
historico_preco|Histórico de preço|Price history|Historial de precios
mcp_tool|Ferramenta MCP|MCP tool|Herramienta MCP
parceiro_nome|Fornecedor ou parceiro|Supplier or partner|Proveedor o socio
compra_condicao_pagamento|Condição de pagamento (compras)|Payment terms (purchasing)|Condición de pago (compras)
compra_forma_pagamento|Forma de pagamento (compras)|Payment method (purchasing)|Forma de pago (compras)
compra_prazo_entrega_dias|Prazo de entrega (dias)|Lead time (days)|Plazo de entrega (días)
compra_pedido_minimo_centavos|Pedido mínimo|Minimum order|Pedido mínimo
compra_observacao|Observação das condições de compra|Purchase terms note|Observación de las condiciones de compra
parceiro_fornecimento|Condições de compra do fornecedor|Supplier purchase terms|Condiciones de compra del proveedor
direito_dias|Direito (dias)|Entitlement (days)|Derecho (días)
link_reuniao|Link da reunião|Meeting link|Enlace de la reunión
reuniao_tipo|Reunião on-line|Online meeting|Reunión en línea
avisar_cliente|Avisar o cliente por e-mail|Notify the customer by e-mail|Avisar al cliente por correo
avisar_convidados|Avisar os convidados por e-mail|Notify guests by e-mail|Avisar a los invitados por correo
`;

/**
 * Review r21 visual (M1): rótulo inteiro da ação gravada na auditoria (Admin > Auditoria, atividade recente, histórico), que
 * `rotuloAcao` consulta antes de juntar palavras. Toda ação de mais de uma palavra que o servidor grava tem linha aqui:
 * `tests/r21-visual-web.test.ts` lê as ações do código (API, worker, kernel e módulos) e confere os três idiomas. As linhas de
 * conta (login, verificação, senha, sessão, fonte e logo) estavam em `CAMPOS`, que a Auditoria não consulta.
 */
const ACOES = `
vincular_empresa|Empresa vinculada ao contato|Company linked to the contact|Empresa vinculada al contacto
desvincular_empresa|Empresa removida do contato|Company removed from the contact|Empresa quitada del contacto
trocar_avatar|Foto do perfil trocada|Profile photo changed|Foto del perfil cambiada
remover_avatar|Foto do perfil removida|Profile photo removed|Foto del perfil quitada
pedido_acesso_criar|Pedido de troca de acesso feito|Access change request made|Solicitud de cambio de acceso hecha
pedido_acesso_aprovar|Pedido de troca de acesso aprovado|Access change request approved|Solicitud de cambio de acceso aprobada
pedido_acesso_recusar|Pedido de troca de acesso recusado|Access change request declined|Solicitud de cambio de acceso rechazada
pedido_acesso_cancelar|Pedido de troca de acesso cancelado|Access change request canceled|Solicitud de cambio de acceso cancelada
trocar_fundo|Fundo da tela de entrada trocado|Sign-in screen background changed|Fondo de la pantalla de entrada cambiado
trocar_logo|Logo da tela de entrada trocada|Sign-in screen logo changed|Logo de la pantalla de entrada cambiado
trocar_textos|Textos da tela de entrada trocados|Sign-in screen texts changed|Textos de la pantalla de entrada cambiados
padrao_fundo|Fundo da tela de entrada de volta ao padrão|Sign-in screen background back to default|Fondo de la pantalla de entrada de vuelta al predeterminado
padrao_logo|Logo da tela de entrada de volta ao padrão|Sign-in screen logo back to default|Logo de la pantalla de entrada de vuelta al predeterminado
trocar_cotacao|Cotação do dólar do uso de IA trocada|AI usage dollar rate changed|Cotización del dólar del uso de IA cambiada
enviar_uso|Uso de IA recebido do medidor|AI usage received from the meter|Uso de IA recibido del medidor
acesso_personalizado|Acesso personalizado da pessoa|Person's custom access|Acceso personalizado de la persona
adiar|Atividades adiadas|Activities postponed|Actividades pospuestas
adicionar_contato|Contato adicionado à negociação|Contact added to the deal|Contacto agregado a la negociación
remover_contato|Contato tirado da negociação|Contact removed from the deal|Contacto quitado de la negociación
adicionar_empresa|Empresa adicional posta na negociação|Additional company added to the deal|Empresa adicional agregada a la negociación
remover_empresa|Empresa adicional tirada da negociação|Additional company removed from the deal|Empresa adicional quitada de la negociación
contato_principal|Contato principal escolhido|Main contact chosen|Contacto principal elegido
excluir_anotacao|Anotação excluída do histórico|Note deleted from the history|Anotación eliminada del historial
criar_proposta|Proposta criada|Proposal created|Propuesta creada
enviar_proposta|Proposta enviada por e-mail|Proposal sent by email|Propuesta enviada por correo
estado_proposta|Status da proposta alterado|Proposal status changed|Estado de la propuesta cambiado
enviar_email|E-mail enviado ao cliente|Email sent to the customer|Correo enviado al cliente
editar_playbook|Playbook da etapa editado|Stage playbook edited|Playbook de la etapa editado
marcar_playbook|Itens do playbook marcados|Playbook items checked|Ítems del playbook marcados
responder_questionario|Questionário respondido|Questionnaire answered|Cuestionario respondido
iniciar_questionario|Questionário iniciado|Questionnaire started|Cuestionario iniciado
excluir_aplicacao_questionario|Questionário excluído da negociação|Questionnaire removed from the deal|Cuestionario eliminado de la negociación
qualificacao|Qualificação alterada|Rating changed|Calificación cambiada
ler_relogio|Leitura do relógio pedida|Time clock read requested|Lectura del reloj solicitada
marcar_verticais|Verticais marcadas|Business units marked|Verticales marcadas
marcar_verticais_lote|Verticais marcadas em lote|Business units marked in bulk|Verticales marcadas en lote
disparar|Disparo enviado ou agendado|Broadcast sent or scheduled|Difusión enviada o programada
registrar|Registrado|Recorded|Registrado
nada|Nenhuma ação|No action|Ninguna acción
enviar_aprovacao|Modelo enviado para aprovação|Template sent for review|Plantilla enviada a revisión
acessar|Acesso|Access|Acceso
responder|Resposta enviada|Reply sent|Respuesta enviada
rodar_agora|Execução pedida ao robô|Robot run requested|Ejecución pedida al robot
gerar_chave|Chave do robô gerada|Robot key generated|Clave del robot generada
virar_tarefa|Pendência virou tarefa|Pending item turned into a task|Pendiente convertido en tarea
gerar_segredo|Segredo do webhook gerado|Webhook secret generated|Secreto del webhook generado
maton_conexao|Conexão criada na Maton|Maton connection created|Conexión creada en Maton
maton_gatilho|Gatilho criado na Maton|Maton trigger created|Disparador creado en Maton
zernio_conectar|Zernio preparada para conectar o número|Zernio prepared to connect the number|Zernio preparada para conectar el número
revogar_chave|Chave do robô revogada|Robot key revoked|Clave del robot revocada
mapear_centros|Mapa centro de custo → empresa salvo|Cost center → company map saved|Mapa centro de costo → empresa guardado
sincronizar|Leitura da Conta Azul pedida|Conta Azul sync requested|Lectura de Conta Azul solicitada
definir_itens|Itens definidos|Items set|Ítems definidos
definir_membros|Equipe definida|Team set|Equipo definido
gerar|Gerado|Generated|Generado
assinar|Assinado|Signed|Firmado
nova_versao|Nova versão|New version|Nueva versión
executar_onboarding|Onboarding executado de novo|Onboarding run again|Onboarding ejecutado de nuevo
iniciar_onboarding|Onboarding iniciado|Onboarding started|Onboarding iniciado
mensagem_equipe|Mensagem da equipe no app|Team message in the app|Mensaje del equipo en la app
personalizar|Modelo personalizado|Template customized|Modelo personalizado
situacao_comercial|Situação comercial alterada|Sales status changed|Situación comercial cambiada
abrir_oportunidade|Oportunidade aberta|Opportunity opened|Oportunidad abierta
classificar|Etiquetas e prioridade alteradas|Labels and priority changed|Etiquetas y prioridad cambiadas
menu|Escolha no menu de entrada|Entry menu choice|Elección en el menú de entrada
presenca|Presença no atendimento|Availability to answer|Presencia en la atención
rotear|Conversa encaminhada pelo menu|Conversation routed by the menu|Conversación encaminada por el menú
adicionar_participantes|Participantes adicionados|Members added|Participantes agregados
alerta_pagamento|Alerta de pagamento|Payment alert|Alerta de pago
aprovacao_prova_falha|Confirmação da aprovação recusada|Approval confirmation refused|Confirmación de la aprobación rechazada
ativar|Ativar|Activate|Activar
atribuir_trilha|Trilha atribuída|Learning path assigned|Ruta asignada
cobranca_enviada|Cobrança enviada|Charge sent|Cobro enviado
cobranca_gerada|Cobrança gerada|Charge created|Cobro generado
concluir_aula|Aula concluída|Lesson completed|Clase completada
concluir_onboarding|Item da integração concluído|Onboarding item completed|Elemento de incorporación completado
conectar_oauth|Conexão por OAuth concluída|OAuth connection completed|Conexión por OAuth completada
configurar_destino|Destino financeiro configurado|Finance destination configured|Destino financiero configurado
definir_centros|Centros de custo definidos|Cost centers set|Centros de costo definidos
definir_habilidade|Habilidade definida|Skill set|Habilidad definida
desarquivar|Desarquivar|Unarchive|Desarchivar
desfazer_conciliacao|Conciliação desfeita|Reconciliation undone|Conciliación deshecha
desfazer_reembolso|Reembolso desfeito (conta a pagar cancelada)|Reimbursement undone (payable canceled)|Reembolso deshecho (cuenta por pagar cancelada)
desligar_modulo|Módulo desligado no workspace|Module turned off in the workspace|Módulo desactivado en el workspace
desligar_tool|Ferramenta MCP desligada|MCP tool turned off|Herramienta MCP desactivada
editar_assinatura|Assinatura das mensagens editada|Message signature edited|Firma de los mensajes editada
editar_retencao|Retenção da caixa de e-mail editada|Mailbox retention edited|Retención del buzón editada
editar_caixa|Tipo ou dono da caixa de e-mail editado|Mailbox type or owner edited|Tipo o dueño del buzón editado
delegar_caixa|Caixa de e-mail delegada|Mailbox delegated|Buzón delegado
retirar_delegacao|Delegação da caixa de e-mail retirada|Mailbox delegation removed|Delegación del buzón retirada
bloquear_caixa|Caixa pessoal bloqueada pelo desligamento|Personal mailbox blocked by the dismissal|Buzón personal bloqueado por la desvinculación
transferir_caixa|Caixa de quem foi desligado transferida|Dismissed person's mailbox transferred|Buzón de la persona desvinculada transferido
encerrar_caixa|Caixa de quem foi desligado encerrada|Dismissed person's mailbox closed|Buzón de la persona desvinculada cerrado
modo_saida|Portal em modo saída|Portal in exit mode|Portal en modo salida
saida_desfeita|Modo saída do Portal desfeito|Portal exit mode undone|Modo salida del Portal deshecho
revogado_por_saida|Acesso ao Portal revogado pelo fim do prazo de saída|Portal access revoked at the end of the exit period|Acceso al Portal revocado al terminar el plazo de salida
exportou_pacote|Pacote de dados baixado no Portal|Data package downloaded from the Portal|Paquete de datos descargado en el Portal
casado_nome|Parceiro casado pelo nome|Partner matched by name|Socio emparejado por el nombre
casado_contato|Parceiro casado pelo e-mail ou telefone|Partner matched by email or phone|Socio emparejado por el correo o teléfono
ler_email|E-mail de caixa alheia lido|Email from another person's mailbox read|Correo de un buzón ajeno leído
retencao_email|Retenção aplicada à caixa de e-mail|Retention applied to the mailbox|Retención aplicada al buzón
emitir_certificado|Certificado emitido|Certificate issued|Certificado emitido
enviar_cliente|Posição financeira enviada ao cliente pelo Portal|Financial position sent to the customer through the portal|Posición financiera enviada al cliente por el portal
despublicar|Retirado do Portal|Removed from the portal|Retirado del portal
publicar_portal|Relatório publicado no Portal do cliente|Report published on the client portal|Informe publicado en el Portal del cliente
despublicar_portal|Relatório retirado do Portal do cliente|Report removed from the client portal|Informe retirado del Portal del cliente
enviar_fonte|Fonte enviada|Font uploaded|Fuente enviada
definir_portfolio|Portfólio da Central definido|Library portfolio set|Portafolio de la Central definido
enviar_logo|Logo enviada|Logo uploaded|Logo enviado
estornar_baixa|Baixa estornada|Settlement reversed|Pago revertido
aplicar_credito|Nota de crédito aplicada em fatura|Credit note applied to invoice|Nota de crédito aplicada en factura
desfazer_aplicacao_credito|Aplicação de crédito desfeita|Credit application undone|Aplicación de crédito deshecha
estornar_perda|Perda estornada|Loss reversed|Pérdida revertida
estorno_asaas|Estorno no Asaas|Refund at Asaas|Reembolso en Asaas
fechar_iniciar|Fechamento iniciado|Close started|Cierre iniciado
fechar_recusado|Fechamento recusado|Close refused|Cierre rechazado
gerar_cobranca|Cobrança gerada|Charge created|Cobro generado
google_calendario|Agenda do Google escolhida|Google Calendar chosen|Calendario de Google elegido
google_iniciar|Conexão do Google Agenda pessoal iniciada|Personal Google Calendar connection started|Conexión de Google Calendar personal iniciada
google_conectar|Google Agenda pessoal conectado|Personal Google Calendar connected|Google Calendar personal conectado
google_desconectar|Google Agenda pessoal desconectado|Personal Google Calendar disconnected|Google Calendar personal desconectado
google_revogado|Acesso ao Google Agenda pessoal recusado pelo Google|Personal Google Calendar access refused by Google|Acceso a Google Calendar personal rechazado por Google
iniciar_oauth|Conexão por OAuth iniciada|OAuth connection started|Conexión por OAuth iniciada
inscrever_push|Aparelho inscrito nas notificações push|Device subscribed to push notifications|Dispositivo suscrito a notificaciones push
lancar_variavel|Variável lançada|Variable entry posted|Variable registrada
ligar_modulo|Módulo ligado no workspace|Module turned on in the workspace|Módulo activado en el workspace
ligar_parceiro|Parceiro vinculado|Partner linked|Socio vinculado
ligar_tool|Ferramenta MCP ligada|MCP tool turned on|Herramienta MCP activada
modo_simples|Modo simples do membro alterado|Member simple mode changed|Modo simple del miembro cambiado
estilo|Estilo do membro alterado|Member style changed|Estilo del miembro cambiado
login_mfa|Login com verificação em duas etapas|Sign in with two-step verification|Inicio de sesión con verificación en dos pasos
login_mfa_backup|Login com código de backup|Sign in with backup code|Inicio de sesión con código de respaldo
login_mfa_bloqueado|Verificação do login bloqueada por tentativas erradas|Sign in verification locked after wrong attempts|Verificación de inicio de sesión bloqueada por intentos erróneos
login_mfa_falha|Código do login recusado|Sign in code refused|Código de inicio de sesión rechazado
mfa_ativar|Verificação em duas etapas ativada|Two-step verification turned on|Verificación en dos pasos activada
mfa_backups_regerar|Códigos de backup gerados de novo|Backup codes regenerated|Códigos de respaldo generados de nuevo
mfa_codigo_falha|Código de verificação recusado|Verification code refused|Código de verificación rechazado
mfa_configurar|Código QR da verificação gerado|Verification QR code generated|Código QR de verificación generado
mfa_desativar|Verificação em duas etapas desativada|Two-step verification turned off|Verificación en dos pasos desactivada
mfa_resetar|Verificação em duas etapas redefinida|Two-step verification reset|Verificación en dos pasos restablecida
mfa_trocar_aparelho|Aparelho da verificação trocado|Verification device switched|Dispositivo de verificación cambiado
acesso_criar|Acesso por nome de usuário criado|Username access created|Acceso por nombre de usuario creado
usuario_teste_marcar|Membro marcado como usuário de teste|Member marked as test user|Miembro marcado como usuario de prueba
usuario_teste_desmarcar|Membro deixou de ser usuário de teste|Member no longer a test user|Miembro dejó de ser usuario de prueba
email_troca_pedir|Troca do e-mail da conta pedida|Account e-mail change requested|Cambio del correo de la cuenta pedido
nome_usuario_trocar|Nome de usuário da conta trocado|Account username changed|Nombre de usuario de la cuenta cambiado
email_trocar_pedir|Troca do e-mail do membro pedida|Member e-mail change requested|Cambio del correo del miembro pedido
email_troca_confirmar|Troca do e-mail da conta confirmada|Account e-mail change confirmed|Cambio del correo de la cuenta confirmado
senha_provisoria_gerar|Nova senha provisória gerada|New temporary password created|Nueva contraseña provisoria generada
formas_acesso|Formas de acesso alteradas|Sign-in methods changed|Formas de acceso cambiadas
senha_link_enviar|Link de nova senha enviado|New password link sent|Enlace de nueva contraseña enviado
mover_e_arquivar|Lançamentos movidos e categoria arquivada|Entries moved and category archived|Movimientos trasladados y categoría archivada
mudar_papel|Papel no canal alterado|Channel role changed|Rol en el canal cambiado
mudar_status|Situação alterada|Status changed|Estado cambiado
niveis_assistente|Níveis de risco dos assistentes alterados|Assistant risk levels changed|Niveles de riesgo de los asistentes cambiados
notificacoes_excecoes|Exceções de notificação alteradas|Notification exceptions changed|Excepciones de notificación cambiadas
notificacoes_excecoes_padrao|Notificações do membro voltaram ao padrão|Member notifications reset to default|Notificaciones del miembro vueltas al predeterminado
notificacoes_padrao|Notificações padrão do papel alteradas|Role default notifications changed|Notificaciones predeterminadas del rol cambiadas
notificacoes_padrao_departamento|Notificações padrão do departamento alteradas|Department default notifications changed|Notificaciones predeterminadas del departamento cambiadas
passkey_cadastrar|Passkey cadastrada|Passkey registered|Passkey registrada
passkey_remover|Passkey removida|Passkey removed|Passkey quitada
promover_dono|Promovido a TI|Promoted to IT|Promovido a TI
reabrir_onboarding|Item da integração reaberto|Onboarding item reopened|Elemento de incorporación reabierto
reajuste_pendente|Reajuste aguardando decisão|Adjustment awaiting decision|Reajuste pendiente de decisión
recusar_reajuste|Reajuste recusado|Adjustment declined|Reajuste rechazado
remover_anexo|Anexo removido|Attachment removed|Adjunto quitado
remover_fonte|Fonte removida|Font removed|Fuente quitada
remover_habilidade|Habilidade removida|Skill removed|Habilidad quitada
remover_logo|Logo removida|Logo removed|Logo quitado
remover_material|Material removido|Material removed|Material quitado
remover_participante|Participante removido|Member removed|Participante quitado
remover_push|Aparelho removido das notificações push|Device removed from push notifications|Dispositivo quitado de las notificaciones push
remover_variavel|Variável removida|Variable entry removed|Variable quitada
repontar_parceiro|Parceiro trocado pela mesclagem|Partner repointed by merge|Socio cambiado por la fusión
retomar|Retomar|Resume|Reanudar
salvar_credencial|Credencial salva|Credential saved|Credencial guardada
senha_falha|Senha atual recusada|Current password refused|Contraseña actual rechazada
senha_trocar|Senha trocada|Password changed|Contraseña cambiada
sessao_encerrar|Sessão encerrada|Session ended|Sesión cerrada
sessoes_encerrar_outras|Outras sessões encerradas|Other sessions ended|Otras sesiones cerradas
usar_geral|Conector só da empresa removido (volta ao de todas as empresas)|Company-only connector removed (back to the all-companies one)|Conector solo de la empresa quitado (vuelve al de todas las empresas)
ver_como_cliente_link|Link de ver como o cliente gerado|View-as-client link created|Enlace de ver como el cliente generado
`;

type Idioma = 'pt' | 'en' | 'es';
const IDX: Record<Idioma, number> = { pt: 1, en: 2, es: 3 };

function tabela(texto: string, idioma: Idioma): Record<string, string> {
  const saida: Record<string, string> = {};
  for (const l of texto.trim().split('\n')) {
    const p = l.split('|');
    saida[p[0]!] = p[IDX[idioma]]!;
  }
  return saida;
}

export function rotulosDe(idioma: Idioma) {
  const vazio = { pt: 'vazio', en: 'empty', es: 'vacío' }[idioma];
  return { vazio, palavras: tabela(PALAVRAS, idioma), modulos: tabela(MODULOS, idioma), campos: tabela(CAMPOS, idioma), acoes: tabela(ACOES, idioma) };
}
